(ns frontend.view.entity-viewers.events.note-editor
  (:require
   [common.localization :as loc]
   [frontend.view.entity-viewers.events.editor-utils :as editor-utils]
   [frontend.actions.entity :as entity-actions]
   [common.schema.registry :as registry]
   [frontend.state.current-session :as session]
   [common.schema.entities.related-entities :as related-entities]
   [common.util :as cu]))

(defn note-editor
  [{:keys [state entity-id externally-passed-entity viewed-entity-id on-reset! metadata-schema show-expanded? props
           on-success-callback!]}]
  (let [viewed-entity-type (:entity/type (session/get-entity viewed-entity-id))
        schema (registry/get-schema @session/tenant-schema :entity.type/note)
        kyc-profile? (= :entity.type/kyc-profile viewed-entity-type)]
    [editor-utils/editor
     {:state                state
      :always-expanded?     show-expanded?
      :full-width?          true
      :activity-entity-id   entity-id
      :externally-passed-entity externally-passed-entity
      :viewed-entity-id     viewed-entity-id
      :activity-entity-type :note
      :wysiwyg-attribute    :note/message
      :placeholder          (loc/tr :note-editor-placeholder)
      :init-draft-state!    (fn [update-draft!]
                              (when viewed-entity-id
                                (update-draft! :common/related-entities #{viewed-entity-id})))
      :entity-schema        (if-not kyc-profile?
                              schema
                              (let [related-keys (->> related-entities/related-entities
                                                      (map first)
                                                      (set))]
                                (->> schema
                                     (remove (fn [[a m]]
                                               (contains? related-keys a))))))
      :mandatory-field?     false
      :on-success-callback! on-success-callback!
      :on-reset!            on-reset!
      :on-submit!           (fn [data on-success! on-error!]
                              (entity-actions/*->create
                               (-> (cu/remove-nil-vals data)
                                   (assoc :entity/type :entity.type/note))
                               (fn [resp]
                                 (on-success! resp)
                                 (when (fn? on-success-callback!)
                                   (on-success-callback! resp)))
                               on-error!))
      :submit-button-text   (loc/tr :create-note-button)
      :disabled-button-tooltip-text (loc/tr :note-add-one-association)}]))
